<template>
    <div id="mail-detail-integration">
        <div class="integrations">
            <span class="fix-align">
                <span class="img">
                    <MailIcon />
                </span>
                <span>
                    <div class="integration-name">{{ $t("mail.gmailForward") }}</div>
                </span>
            </span>
        </div>
        <div class="forwards">
            <div class="forward forward-add" @click="gmailIntegration(true)">
                <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                <span class="text-large font-weight-bolder mt-2" style="font-size: 15px">
                    {{ $t("settings.newAdd") }}
                </span>
            </div>

            <div class="forward-item" v-for="forwardAddress of forwardAddresses">
                <div class="icon-container">
                    <MailIcon style="width: 40px; height: 40px" />
                </div>
                <a-tooltip :title="forwardAddress.mail">
                    <span class="forward-mail-address">{{ forwardAddress.mail }}</span>
                </a-tooltip>
            </div>
        </div>
        <div class="integrations">
            <span class="fix-align">
                <span class="img">
                    <MicrosoftIcon />
                </span>
                <span>
                    <div class="integration-name">{{ $t("mail.outlookForward") }}</div>
                </span>
            </span>
        </div>
        <div class="forwards">
            <div class="forward forward-add" @click="gmailIntegration(false)">
                <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                <span class="text-large font-weight-bolder mt-2" style="font-size: 15px">
                    {{ $t("settings.newAdd") }}
                </span>
            </div>
            <div class="forward-item" v-for="forwardAddress of microsoftForwardAddresses">
                <div class="icon-container">
                    <MailIcon style="width: 40px; height: 40px" />
                </div>
                <a-tooltip :title="forwardAddress.mail">
                    <span class="forward-mail-address">{{ forwardAddress.mail }}</span>
                </a-tooltip>
            </div>
        </div>
        <a-modal v-model="isGmailIntegration" class="testModal2" title="Yönlendirme Adımları" centered @ok="closeModal">
            <div>
                <gif-player :src="getGifSrc()"></gif-player>
            </div>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import MailIcon from "../icons/MailIcon.vue";
import MicrosoftIcon from "../icons/MicrosoftIcon.vue";

const log = log2("Integration.vue");
export default Vue.extend({
    name: "Integration",
    components: {
        MailIcon,
        MicrosoftIcon,
    },
    data() {
        return {
            selectedId: this.$route.params.id,
            selectedMail: "",
            isGmailIntegration: false,
            emailDomainEnabled: true,
            forwardAddresses: [],
            microsoftForwardAddresses: [],
            isGmailForward: false,
        };
    },
    computed: {
        ...mapState({
            allMailAddresses: (state) => state.mail.allMailAddresses,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            domainIsCreated: (state) => state.mail.domainIsCreated,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        getGifSrc() {
            if (!!this.isGmailForward) return `https://static.supsis.live/common/email/screenshot/gmail.mp4`;
            else return `https://static.supsis.live/common/email/screenshot/outlook.mp4`;
        },
        gmailIntegration(isGmail = false) {
            this.isGmailForward = isGmail;
            this.isGmailIntegration = true;
        },
        closeModal() {
            this.isGmailIntegration = false;
        },
    },
    mounted() {
        console.log("allMailAddresses mounted...", this.allMailAddresses);

        const selectedMail = this.allMailAddresses.find(
            (email) => email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
        );
        console.log("integration selectedMail...", selectedMail);

        this.forwardAddresses = this.allMailAddresses.filter(
            (email) =>
                email.forwardTo === selectedMail.mail &&
                !!email.isForward &&
                !!email.isVerified &&
                email.isForwardPlatform === "gmail"
        );

        this.microsoftForwardAddresses = this.allMailAddresses.filter(
            (email) =>
                email.forwardTo === selectedMail.mail &&
                !!email.isForward &&
                !!email.isVerified &&
                email.isForwardPlatform === "microsoft"
        );
        console.log("integration page...", this.forwardAddresses);
    },
    watch: {
        allMailAddresses(val) {
            console.log("integration allMailAddresses...", this.allMailAddresses);
            const selectedMail = this.allMailAddresses.find(
                (email) =>
                    email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
            );
            this.forwardAddresses = this.allMailAddresses.filter(
                (email) =>
                    email.forwardTo === selectedMail.mail &&
                    email.isForwardPlatform === "gmail" &&
                    !!email.isForward &&
                    !!email.isVerified
            );

            this.microsoftForwardAddresses = this.allMailAddresses.filter(
                (email) =>
                    email.forwardTo === selectedMail.mail &&
                    !!email.isForward &&
                    !!email.isVerified &&
                    email.isForwardPlatform === "microsoft"
            );
        },
    },
});
</script>

<style scoped lang="scss">
#mail-detail-integration {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;
    padding: 30px;

    .forwards {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .gmail-forward {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            width: 170px;
            height: 150px;
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        .forward {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 170px;
            height: 150px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }
        }

        .forward-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 170px;
            height: 150px;
            margin-top: 10px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .web-hook-title {
                word-break: break-all;
            }

            &.disabled {
                opacity: 0.5;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);
            }

            .icon-container {
                margin: 0 auto;
                width: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                padding: 10px;
                margin-top: -20px;
            }

            .forward-mail-address {
                font-size: 13px !important;
                font-weight: 400 !important;
                max-width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            span {
                font-weight: bold;
                display: block;
                font-size: 16px;
                transition: 10ms;
            }
        }

        .forward-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }

    .forward-name {
        display: flex;
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        color: #121317;
        margin-bottom: 10px;
        margin-top: 30px;
    }

    .integration-name {
        color: #121317;
        font-size: 15px;
        font-weight: 500;
        display: flex;
        flex-direction: column;
    }

    .integrations {
        height: 80px;
        border: 1px solid #c7d0d7;
        margin-top: 10px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .fix-align {
            display: flex;
            align-items: center;

            .done {
                color: #1999e3;
                margin-right: 5px;
                font-size: 20px;
            }

            .connected-name {
                color: #1999e3;
            }

            .connect-button {
                border: 1px solid black;
                padding: 5px 10px 5px 10px;
                background: white;
                border-radius: 5px;

                &.disabled {
                    border-color: rgba(0, 0, 0, 0.26);
                    cursor: default;
                }

                .connect-name {
                    color: black;

                    &.disabled {
                        color: rgba(0, 0, 0, 0.26);
                    }
                }
            }
        }

        .forward {
            font-size: 13px !important;
            font-weight: 400 !important;
        }

        .domain-name {
        }

        .img {
            width: 40px;
            height: 40px;
            margin-right: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .upload-image {
            display: flex;
            width: 40px;
            height: 40px;
        }
    }
}
</style>
